<template>
  <div id="content-wrapper" class="nhap-ma-kich-hoat otp-scope">
    <div class="otp-page-head">
      <h5 class="otp-page-title">Nhập mã kích hoạt xác thực 2 bước</h5>
      <p class="otp-page-sub">
        Nhập mã 6 số đã được gửi tới email của bạn. Mã có hiệu lực trong 5 phút.
      </p>
    </div>
    <b-form-group
      label="Mã kích hoạt"
      label-class="font-weight-bold"
      label-for="input-ma-kich-hoat"
      class="form-row-otp"
    >
      <b-form-input
        id="input-ma-kich-hoat"
        v-otp-autofocus
        v-model="code"
        type="text"
        inputmode="numeric"
        maxlength="6"
        autocomplete="one-time-code"
        pattern="[0-9]*"
        placeholder="Mã 6 số"
        @keyup.enter="verify"
      />
    </b-form-group>
    <div class="mt-3">
      <base-button button="Xác nhận" @click="verify" :disabled="isLoading || !code"></base-button>
    </div>
    <BaseLoading :is-loading="isLoading" />
  </div>
</template>

<script>
import BaseLoading from "../../common/BaseLoading";

// Phase 7C UC11: màn user tự nhập mã kích hoạt (email) -> verify. Gửi code dạng CHUỖI (giữ số 0 đầu -
// type="number" sẽ mất "0" ở đầu như "012345"). Không hard-gate luồng setup (đó là Phase 9).
export default {
  name: "NhapMaKichHoatOtp",
  components: { BaseLoading },
  data() {
    return { code: null, isLoading: false };
  },
  methods: {
    verify() {
      if (!this.code) return;
      this.isLoading = true;
      this.$store
        .dispatch("common/verifyActivation", { code: String(this.code).trim() })
        .then((res) => {
          this.isLoading = false;
          if (res.succeeded) {
            this.$toasted.clear();
            this.$toasted.global.showSuccessMessage({
              message: "Xác thực mã kích hoạt thành công. Bạn có thể thiết lập lại xác thực 2 bước.",
            });
            this.code = null;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toasted.clear();
          this.$toasted.global.showErrorMessage({
            message: (err && err.data && err.data.message) || "Mã không đúng hoặc đã hết hạn",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// Reskin OTP (Phase 3): overlay token + typography. Giữ input type=text (số 0 đầu) - KHÔNG đụng script.
// max-width giới hạn form (màn đơn field) để không kéo dài trên desktop rộng.
.nhap-ma-kich-hoat {
  max-width: 480px;
  font-family: var(--otp-sans);
  font-size: 14px;
  color: var(--otp-ink);

  .otp-page-head {
    margin-bottom: 20px;
  }
  .otp-page-title {
    font-family: var(--otp-display);
    font-weight: 600;
    font-size: 20px;
    color: var(--otp-ink);
    margin: 0 0 6px;
  }
  .otp-page-sub {
    color: var(--otp-muted);
    font-size: 13.5px;
    margin: 0;
  }

  .form-row-otp {
    max-width: 220px;
    ::v-deep input {
      font-family: var(--otp-mono);
      font-size: 18px;
      letter-spacing: 0.15em;
      text-align: center;
      border-color: var(--otp-border-strong);
      &:focus {
        border-color: var(--otp-blue);
        box-shadow: var(--otp-ring);
      }
    }
  }
}
</style>
